import SEO from "@/components/SEO";
import { MapPin, Phone, Envelope, Clock } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function ContactPage() {
  return (
    <>
      <SEO
        title="Contact — MECA AUTO 17 Tonnay-Charente | Adresse, Téléphone, Horaires"
        description="Contactez MECA AUTO 17 à Tonnay-Charente 17430. Adresse, téléphone, horaires, plan d'accès. Devis gratuit et rendez-vous en ligne."
      />
      <section className="pt-32 pb-12 px-6 md:px-12 bg-[#0D2C54] text-white">
        <div className="max-w-[1400px] mx-auto">
          <span className="overline text-[#E63946]">Contact</span>
          <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight max-w-3xl">Trouvez-nous, appelez-nous, passez nous voir.</h1>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-12 bg-white">
        <div className="max-w-[1400px] mx-auto grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4 space-y-px bg-[#E5E7EB] border border-[#E5E7EB]">
            {[
              { icon: MapPin, t: "Adresse", lines: ["49 Av. Charles de Gaulle", "17430 Tonnay-Charente"] },
              { icon: Phone, t: "Téléphone", lines: ["05 46 88 70 88"], href: "tel:+33546887088" },
              { icon: Envelope, t: "Email", lines: ["mecaauto17@gmail.com"], href: "mailto:mecaauto17@gmail.com" },
              { icon: Clock, t: "Horaires", lines: ["Lun – Ven : 8h – 18h30", "Samedi : 9h – 17h", "Dimanche : Fermé"] },
            ].map((it, i) => (
              <div key={i} data-testid={`contact-info-${i}`} className="bg-white p-6 md:p-8">
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 bg-[#0D2C54] flex items-center justify-center shrink-0">
                    <it.icon size={20} className="text-white" weight="duotone" />
                  </div>
                  <div>
                    <h3 className="overline text-[#E63946]">{it.t}</h3>
                    <div className="mt-2 text-[#333333] space-y-1">
                      {it.lines.map((l, j) =>
                        it.href ? (
                          <a key={j} href={it.href} className="block hover:text-[#E63946]">{l}</a>
                        ) : (<div key={j}>{l}</div>)
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="lg:col-span-8">
            <div className="aspect-[16/10] border border-[#E5E7EB] overflow-hidden">
              <iframe
                title="Google Maps – MECA AUTO 17"
                src="https://www.google.com/maps?q=49+Avenue+Charles+de+Gaulle+17430+Tonnay-Charente&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="contact-map"
              />
            </div>
            <div className="mt-8 bg-[#F8F9FA] border border-[#E5E7EB] p-6 md:p-8 flex flex-col md:flex-row gap-4 md:items-center md:justify-between">
              <div>
                <h3 className="font-display font-semibold text-xl text-[#0D2C54]">Une intervention urgente ?</h3>
                <p className="text-[#555555] text-sm mt-2">Notre équipe est disponible 6 jours sur 7 pour vous accompagner.</p>
              </div>
              <div className="flex gap-3">
                <Link to="/rendez-vous"><Button data-testid="contact-rdv-btn" className="bg-[#E63946] hover:bg-[#D62839] rounded-none h-12 px-6 font-semibold">Prendre rendez-vous</Button></Link>
                <a href="tel:+33546887088"><Button data-testid="contact-call-btn" variant="outline" className="rounded-none h-12 px-6 border-[#0D2C54] text-[#0D2C54] hover:bg-[#0D2C54] hover:text-white font-semibold">Nous appeler</Button></a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
